import React, { Fragment } from 'react';
import {
  Grid,
  Paper,
  Card,
  CardHeader,
  CardContent,
  makeStyles,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  full: {
    minWidth: '100%',
  },
}));

export default function LoadinSkeleton() {
  const classes = useStyles();
  const quiebre = useMediaQuery('(max-width:475px)');

  const num = quiebre ? 1 : 3;

  return (
    <Fragment>
      {Array.from(new Array(num)).map((item, index) => (
        <Grid key={index} xs={12} sm={quiebre ? 12 : 4} style={{ padding: '10px' }}>
          <Paper spacing={2}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Skeleton animation='wave' variant='circle' width={40} height={40} />
                }
                title={
                  <Skeleton
                    animation='wave'
                    height={10}
                    width='80%'
                    style={{ marginBottom: 6 }}
                  />
                }
                subheader={<Skeleton animation='wave' height={10} width='40%' />}
              />
              <Skeleton animation='wave' variant='rect' height={100} />
              <CardContent>
                <React.Fragment>
                  <Skeleton animation='wave' height={30} width='100%' />
                </React.Fragment>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
      ))}
    </Fragment>
  );
}
